module.exports = ".add-server, \r\n.server-statuses {\r\n    width: 300px;\r\n    margin: 10px 0px;\r\n}\r\n\r\nbutton{\r\n    margin: 10px 0px;\r\n}\r\n\r\n.serverCreationStatus {\r\n    font-size: 90%;\r\n    color: gray;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/server-console-1/servers/servers.component.css
// module id = ./src/app/components/server-console-1/servers/servers.component.css
// module chunks = main